import { render, staticRenderFns } from "./TrashCanOutlineIcon.vue?vue&type=template&id=3e671be1"
import script from "./TrashCanOutlineIcon.vue?vue&type=script&lang=js"
export * from "./TrashCanOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports